const MIN_TERMS_LENGTH = 3;

interface GrowthbookContext {
  isReady?: boolean;
  features?: Record<string, unknown>;
}

/**
 * بلوکِ «نتایج» (کارتِ پزشک‌ها) داخلِ باکسِ پیشنهادِ جستجو.
 *
 * fail-closed: فقط وقتی فلگ‌های GrowthBook رسیده‌اند **و** `is_instant_search_enabled` روشن است نشان داده می‌شود.
 * شرطِ قبلی برعکس بود («اگر رسیده و خاموش است، نشان نده»)، پس تا رسیدنِ فلگ‌ها — یا در کلِ بازدید اگر
 * درخواستِ فلگ‌ها شکست می‌خورد — کاربر بلوکی را می‌دید که برای همه خاموش شده بود.
 */
export const shouldShowInstantResults = (terms: unknown, growthbook: GrowthbookContext | undefined): boolean => {
  if (typeof terms !== 'string' || terms.trim().length < MIN_TERMS_LENGTH) return false;

  return growthbook?.isReady === true && growthbook.features?.is_instant_search_enabled === true;
};

export default shouldShowInstantResults;
